import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export const USER_IDENTITY_NAME_VIRTUAL_COLUMN_ID = "4967b6dc-4b91-4f16-ad0a-f0ef0c1808b2" as Uuid;
export const USER_IDENTITY_EMAIL_VIRTUAL_COLUMN_ID = "77bb2b64-26f8-490b-ac57-322676d9e26b" as Uuid;
export const USER_IDENTITY_PHONE_NUMBER_VIRTUAL_COLUMN_ID = "97233fff-b0ff-411e-8c95-c992eca58729" as Uuid;

export const USER_IDENTITY_VIRTUAL_COLUMN_IDS = {
    email: USER_IDENTITY_EMAIL_VIRTUAL_COLUMN_ID,
    name: USER_IDENTITY_NAME_VIRTUAL_COLUMN_ID,
    phoneNumber: USER_IDENTITY_PHONE_NUMBER_VIRTUAL_COLUMN_ID,
} as const satisfies Record<string, Uuid>;

export type UserIdentityVirtualColumnKey = keyof typeof USER_IDENTITY_VIRTUAL_COLUMN_IDS;
